<div class="page-container">

    <!-- Header: 车型选择 -->
    <header class="header" *ngIf="showHeader && vehicleList.length > 0">
        <div class="header-main">
            <div class="vehicle-info" (click)="toggleHeader()">
                <div class="title">{{ vehicleList[0].carFullInfo }}</div>
                <div class="expand-hint">
                    <span>{{ isHeaderExpanded ? '收起' : '展开' }}</span>
                    <i class="icon-arrow" [class.up]="isHeaderExpanded"></i>
                </div>
            </div>
            <div class="reselect-btn" (click)="reChoose()">
                <i class="icon-swap"></i>
                <span>重选</span>
            </div>
        </div>

        <!-- 车型折叠层 -->
        <div class="dropdown-overlay" *ngIf="isHeaderExpanded" (click)="toggleHeader()">
            <div class="dropdown-content" (click)="$event.stopPropagation()">
                <ul>
                    <li *ngFor="let carInfo of vehicleList" style="display: block;">
                        <div>
                            <span class="dot">■</span>
                            {{ carInfo.carFullInfo }}
                        </div>
                        <div *ngIf="carInfo.engineOilOeGuideline" style="margin-top: 5px;">
                            {{ carInfo.engineOilOeGuideline }}
                        </div>
                    </li>
                </ul>
                <div class="collapse-btn" (click)="toggleHeader()">
                    收起 <i class="icon-arrow up"></i>
                </div>
            </div>
        </div>
    </header>

    <!-- 主体区域 -->
    <nz-spin [nzSpinning]="isContentLoading" nzTip="loading...">
        <div class="main-body">

            <!-- 左侧：产品组 (Category1) -->
            <aside class="sidebar-left">
                <ul>
                    <li *ngFor="let cat of categories" [class.active]="selectedCategoryId === cat.id"
                        (click)="selectCategory(cat.id)">
                        {{ cat.name }}
                    </li>
                </ul>
            </aside>

            <!-- 右侧内容 -->
            <section class="content-right">

                <!-- 顶部筛选条：Tab (Category2) -->
                <div class="filter-bar">
                    <div class="scroll-tabs">
                        <div class="tab-item" *ngFor="let sub of subCategories"
                            [class.selected]="selectedSubCategoryIds.has(sub.id)" (click)="toggleSubCategory(sub)">
                            {{ sub.name }}
                        </div>
                    </div>
                    <!-- 筛选按钮 -->
                    <div class="filter-icon" (click)="openFilter()">
                        <i class="icon-filter"></i>
                        <span>筛选</span>
                    </div>
                </div>

                <!-- 产品列表 (卡片) -->
                <!-- <nz-spin [nzSpinning]="isTableLoading" nzTip="loading..."> -->
                <div class="product-list" #scrollContainer>
                    <!-- 产品卡片 -->
                    <div class="product-card" *ngFor="let p of displayProducts">
                        <div class="card-content" (click)="goDetail(p.partId)">
                            <div class="prod-img">
                                <div class="img-placeholder">
                                    <img class="part-img" [src]="getImage(p.imageList)" alt="图" />

                                    <div class="status-badge" *ngIf="p.partNoStatus">
                                        <nz-tag [ngClass]="p.partNoStatus === '在售' ? 'in-sale' : 'shutdown'">
                                            {{ p.partNoStatus }}
                                        </nz-tag>
                                    </div>
                                </div>
                            </div>

                            <div class="prod-info">
                                <div class="prod-name">{{ p.partName }}</div>

                                <div class="prod-code">
                                    <span>
                                        {{ p.partNo }}
                                    </span>
                                    <!-- <i class="icon-copy" (click)="copyText(p.partNo)"></i> -->
                                    <i nz-icon nzType="copy" (click)="copyText(p.partNo); $event.stopPropagation()"
                                        style="cursor: pointer; margin-left: 5px; color: #007BC0;"></i>
                                </div>
                                <!-- 尺寸 -->
                                <div *ngFor="let featureItem of filterFeature(p); let i = index">
                                    <span *ngIf="(p.category1Name.includes('雨刮')) && (featureItem.featureNameCn === '长度 1（英寸）' || 
                                                                                featureItem.featureNameCn === '长度 2（英寸）' || 
                                                                                featureItem.featureNameCn === '长度 1' || 
                                                                                featureItem.featureNameCn === '长度 2' || 
                                                                                featureItem.featureNameCn === '雨刮1长度' || 
                                                                                featureItem.featureNameCn === '雨刮2长度(仅套装)')">
                                        {{editFeatureNameCn(featureItem.featureNameCn,
                                        p.partNo)}}:{{Math.round(parseFloat(featureItem.featureValue))}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer"
                            *ngIf="p.typeFormular || ifRemarkExist(p.remarkExternalList)">
                            <div class="footer-info" *ngIf="p.typeFormular">
                                别称: {{ p.typeFormular }}
                            </div>
                            <div *ngFor="let remark of p.remarkExternalList;">
                                <a *ngIf="hasVideoUrl(p.categoryName,remark)"
                                    (click)="openVideoModal(p.categoryName,remark)"
                                    style="cursor:pointer; color:#1890ff;">
                                    {{ getRemarks(remark, p.categoryName) }}
                                    <i nz-icon nzType="video-camera" nzTheme="outline"></i>
                                </a>
                                <span *ngIf="!isVideoModal(remark)">{{remark}}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 加载更多中（滚动触发） -->
                    <div class="loading" *ngIf="loadingMore">
                        <nz-spin nzSimple></nz-spin>
                        <span class="loading-text">加载中...</span>
                    </div>

                    <!-- 没有更多 -->
                    <div class="no-more" *ngIf="!loadingMore && !hasMore && displayProducts.length > 0">
                        没有更多产品了
                    </div>

                    <!-- IntersectionObserver 锚点 -->
                    <div #loadMoreAnchor class="load-more-anchor"></div>

                    <!-- 完全空状态 -->
                    <div class="empty-state" *ngIf="!loadingMore && displayProducts.length === 0">
                        暂无相关产品数据
                    </div>

                    <!-- 底部留白 -->
                    <div style="height: 40px;"></div>
                </div>
                <!-- </nz-spin> -->
            </section>
        </div>
    </nz-spin>

    <!-- 底部多选模态框 -->
    <div class="filter-modal-overlay" *ngIf="isFilterOpen">
        <div class="mask" (click)="closeFilter()"></div>

        <div class="bottom-sheet">
            <div class="sheet-header">
                <span class="sheet-title">请选择产品类型（可多选）</span>
                <i class="close-btn" (click)="closeFilter()">×</i>
            </div>

            <div class="sheet-body">
                <div class="tag-grid">
                    <!-- 循环展示当前大类下的所有子类 -->
                    <div class="tag-item" *ngFor="let tag of filterTags"
                        [class.active]="tempSelectedFilterIds.has(tag.id)" (click)="toggleFilterTag(tag.id)">
                        {{ tag.name }}
                    </div>
                </div>
            </div>

            <div class="sheet-footer">
                <button class="btn btn-clear" (click)="clearFilters()">清空</button>
                <button class="btn btn-confirm" (click)="confirmFilters()">确认</button>
            </div>
        </div>
    </div>

</div>